"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;

var _translation_utils = require("../../translation_utils");

var _jsxRuntime = require("react/jsx-runtime");

let Checkbox = ({
  id,
  schemaTypeName,
  name,
  onChange,
  onBlur,
  defaultValue,
  inputRef,
  styles = {},
  field
}) => {
  const defaultChecked = defaultValue !== 'false' && defaultValue;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles.checkboxWrap,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      id: id,
      type: "checkbox",
      name: name,
      onChange: onChange,
      onBlur: onBlur,
      defaultChecked: defaultChecked,
      className: styles.checkbox,
      ref: inputRef
    }, "val"), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      htmlFor: id,
      className: styles.checkboxLabel,
      children: (0, _translation_utils.trModel)(schemaTypeName, name)
    }, "label")]
  }, name);
};

exports.Checkbox = Checkbox;